import React, { useState } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import { POWERUPS } from '../economy/economyCatalog';
import CoinIcon from './icons/CoinIcon';
import AddCoinsPill from './coins/AddCoinsPill';
import './ZoomOutButton.css';

const ZoomOutButton = ({
  onZoomOut,
  disabled,
  freeZoomOutsRemaining = 0,
  onBlockedClick,
}) => {
  const { coins } = useProfile();
  const [isProcessing, setIsProcessing] = useState(false);
  const ZOOM_OUT_COST = POWERUPS.zoom_out.uiCostCoins;

  const handleZoomOut = async () => {
    if (disabled || isProcessing) return;
    if (freeZoomOutsRemaining <= 0 && coins < ZOOM_OUT_COST) {
      onBlockedClick?.();
      return;
    }

    setIsProcessing(true);
    try {
      await onZoomOut();
    } finally {
      setIsProcessing(false);
    }
  };

  const canAfford = freeZoomOutsRemaining > 0 || coins >= ZOOM_OUT_COST;
  const showAddCoins = freeZoomOutsRemaining <= 0 && coins < ZOOM_OUT_COST;

  const costLabel = freeZoomOutsRemaining > 0 ? `Free: ${freeZoomOutsRemaining}` : null;
  const costClass =
    freeZoomOutsRemaining > 0 ? 'cost-indicator free' : 'cost-indicator';

  const disableMainAction = !canAfford || disabled || isProcessing;
  // IMPORTANT: when user is broke, don't use the HTML "disabled" attribute,
  // otherwise the embedded "Add Coins" pill cannot be clicked.
  const useNativeDisabled = disableMainAction && !showAddCoins;

  return (
    <div className="zoomout-button-wrap">
      <button
        className={`zoomout-button ${disableMainAction ? 'disabled' : ''} ${showAddCoins ? 'add-coins-state' : ''}`.trim()}
        onClick={handleZoomOut}
        disabled={useNativeDisabled}
        aria-disabled={disableMainAction}
      >
        <span className="label">{isProcessing ? 'Zooming...' : 'Zoom Out'}</span>
        {costLabel ? (
          <span className={costClass}>{costLabel}</span>
        ) : (
          <span className={costClass}>
            {ZOOM_OUT_COST}
            <CoinIcon />
          </span>
        )}

        {showAddCoins && <AddCoinsPill className="cost-indicator add-coins-pill" />}
      </button>
    </div>
  );
};

export default ZoomOutButton;

